<template>
    <home-layout>
        <template v-slot:products>
            <CustomSearchTitleArea/>
            <CustomProductsSelector v-model="product"/>
        </template>
        <template v-slot:content>
            <div class="px-3 px-md-5 py-0">
                <VoloHotelSearchForm v-if="isProductVoloHotel" @change="setSearchType"/>
                <TourAccompagnatoSearchForm v-if="isProductTour" @change="setSearchType"/>
                <ExperienceSearchForm v-if="isProductExperience" @change="setSearchType"/>
            </div>
            <div class="p-3 p-md-5">
                <OfferteSpeciali v-if="isProductVoloHotel"/>
            </div>
            <div v-if="hasTours" class="prossimi-tour-area py-5 bg-white">
                <ProssimiTourMobile v-if="isMobile" title="Non vedi l'ora di partire?" subtitle="scopri i prossimi tour in partenza"/>
                <ProssimiTour v-else title="Non vedi l'ora di partire?" subtitle="scopri i prossimi tour in partenza"/>
            </div>
        </template>
        <template v-slot:content-footer>
            <div class="gray-area py-5">
                <CustomStaticsArea class="container"/>
            </div>
            <CustomSelectionMap class="py-5"/>
            <CustomParallaxArea/>
            <ScrollToTop/>
        </template>
    </home-layout>
</template>

<script>
import {mapGetters} from 'vuex'
import HomeLayout from './layout/HomeLayout'
import OfferteSpeciali from '../widgets/pages/home/OfferteSpeciali'
import ProssimiTour from '../widgets/pages/home/ProssimiTour'
import ProssimiTourMobile from '../mobile/widgets/pages/home/ProssimiTour'
import {PRODUCT_VOLO_HOTEL, PRODUCT_TOUR, PRODUCT_EXPERIENCE} from '../../types/products'
import VoloHotelSearchForm from '../widgets/pages/home/VoloHotelSearchForm'
import TourAccompagnatoSearchForm from '../widgets/pages/home/TourAccompagnatoSearchForm'
import ExperienceSearchForm from '../widgets/pages/home/ExperienceSearchForm'
import MainLoader from '../loader/MainLoader'
import MobileDetector from '../common/MobileDetector'
import ScrollToTop from '../common/ScrollToTop'

export default {
  name: 'Home',
  mixins: [MainLoader, MobileDetector],
  components: {
    ScrollToTop,
    ExperienceSearchForm,
    TourAccompagnatoSearchForm,
    VoloHotelSearchForm,
    ProssimiTour,
    ProssimiTourMobile,
    OfferteSpeciali,
    HomeLayout
  },
  data: () => {
    return {
      product: PRODUCT_VOLO_HOTEL
    }
  },
  computed: {
    isProductVoloHotel () {
      return this.product === PRODUCT_VOLO_HOTEL
    },
    isProductTour () {
      return this.product === PRODUCT_TOUR
    },
    isProductExperience () {
      return this.product === PRODUCT_EXPERIENCE
    }
  },
  methods: {
    ...mapGetters(['getSearch', 'hasTours']),
    init () {
      this.init()
      const search = this.getSearch()
      if (search && search.product) {
        this.product = search.product
      } else {
        this.product = PRODUCT_VOLO_HOTEL
      }
    },
    resizeIframe (obj) {
      obj.style.height = obj.contentWindow.document.documentElement.scrollHeight + 'px'
    },
    setSearchType (type) {
      window.localStorage.search = type
    }
  },
  created () {
    if (window.localStorage.search) {
      delete window.localStorage.search
    }
    this.initApp()
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/pages/Home.vue